module.exports = __webpack_public_path__ + "img/clarity-head.4fdb01f5.png";